// @ts-nocheck
/* eslint-disable */
export var prepareAnalytics = function (w, d, s, c, t, a, m) {
    var analytics = function () {
        (w[t] =
            w[t] ||
                function () {
                    (w[t].q = w[t].q || []).push(arguments);
                }),
            (w[t].l = 1 * new Date());
        (a = d.createElement(s)), (m = d.getElementsByTagName(s)[0]);
        a.async = 1;
        a.src = c;
        m.parentNode.insertBefore(a, m);
    };
    analytics();
};
